var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FF4D61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0053 18H41.88V20.8747H37.88V23.7493H41.88V26.624H35.0053V18ZM43.2533 18H50.1307V20.5013H46.1307V21H50.1307V26.7493H43.2533V24.1253H47.2533V23.624H43.2533V18ZM51.5067 18H58.3787V20.5013H54.3787V21H58.3787V26.7493H51.5067V24.1253H55.5067V23.624H51.5067V18Z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.976 82L28.4587 76.8587L23 30.5787H71L65.544 76.8533L46.976 82ZM33.792 51.528L34.3013 57.2027H53.9733L53.3147 64.5627L46.984 66.2747H46.9787L40.6587 64.568L40.2533 60.0427H34.5547L35.3493 68.9547L46.976 72.1813L58.6213 68.9547L60.04 53.0507L60.1787 51.528L61.2027 40.0373H32.7707L33.288 45.7147H54.984L54.4667 51.528H33.792Z",
    fill: "#111827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(15 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.842ab3e386b10b00f6887c133840dc67.svg";
export { ForwardRef as ReactComponent };